module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-tasks-1bb307d7d1cbcdf59f3c2f52935bd301.svg";